import api from "./Api";

class GwayAgenteService {
  gerarCodigo(idDestino) {
    return api
      .post("/v1/gway-agente/vinculos/restaurante-destino/" + idDestino)
      .then((response) => response.data);
  }

  gerarCodigoDestinoFixo(modulo, codigo) {
    return api
      .post(
        "/v1/gway-agente/vinculos/destino-fixo/" +
          encodeURIComponent(modulo) +
          "/" +
          encodeURIComponent(codigo)
      )
      .then((response) => response.data);
  }

  getDestinosWeb() {
    return api
      .get("/v1/gway-agente/web/restaurante/destinos")
      .then((response) => response.data);
  }

  getDestinosFixosWeb(modulo) {
    return api
      .get("/v1/gway-agente/web/destinos-fixos/" + encodeURIComponent(modulo))
      .then((response) => response.data);
  }

  getAgentesWeb() {
    return api
      .get("/v1/gway-agente/web/agentes")
      .then((response) => response.data);
  }

  desvincularAgente(guid) {
    return api
      .delete("/v1/gway-agente/web/agentes/" + guid)
      .then((response) => response.data);
  }

  desvincularDestino(id) {
    return api
      .delete("/v1/gway-agente/web/restaurante/destinos/" + id + "/dispositivo")
      .then((response) => response.data);
  }

  desvincularDestinoFixo(modulo, codigo) {
    return api
      .delete(
        "/v1/gway-agente/web/destinos-fixos/" +
          encodeURIComponent(modulo) +
          "/" +
          encodeURIComponent(codigo) +
          "/dispositivo"
      )
      .then((response) => response.data);
  }

  testarImpressao(id) {
    return api
      .post("/v1/gway-agente/web/restaurante/destinos/" + id + "/teste")
      .then((response) => response.data);
  }

  testarImpressaoDestinoFixo(modulo, codigo) {
    return api
      .post(
        "/v1/gway-agente/web/destinos-fixos/" +
          encodeURIComponent(modulo) +
          "/" +
          encodeURIComponent(codigo) +
          "/teste"
      )
      .then((response) => response.data);
  }

  getFilaImpressao(pagina = 1, registros = 20) {
    return api
      .get(
        "/v1/gway-agente/web/fila-impressao?pagina=" +
          pagina +
          "&registros=" +
          registros
      )
      .then((response) => response.data);
  }

  removerTrabalhoImpressao(id) {
    return api
      .delete("/v1/gway-agente/web/fila-impressao/" + id)
      .then((response) => response.data);
  }

  reenfileirarTrabalhoImpressao(id) {
    return api
      .post("/v1/gway-agente/web/fila-impressao/" + id + "/reenviar")
      .then((response) => response.data);
  }

  limparFilaImpressao() {
    return api
      .delete("/v1/gway-agente/web/fila-impressao")
      .then((response) => response.data);
  }
}

export default new GwayAgenteService();
